export default "__VITE_ASSET__1rkS3YfP__"